var map = {
	"./swiper-1.jpg": "+uCx",
	"./swiper-2.jpg": "pcqw",
	"./swiper-3.jpg": "bWU6",
	"./swiper-4.jpg": "s7oN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mS51";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/swiper ^\.\/swiper\-.*\.jpg$
// module id = mS51
// module chunks = 0